module.exports = __webpack_public_path__ + "static/media/link-logo-raymond.29b56207.jpg";